import store from "@/store";
import { getQuerystringParameter } from "@/helpers/querystring-helper";
import { queryStrings } from "@/constants/query-strings";
import { storeActions } from "@/constants/store-actions";

// useStyle highlights the message and data (not the timestamp) so it stands out in the console.
export function debugLog(message, data, forceLog = false, useStyle = false) {
    const styled =
        "background: #ffd400; color: #000; font-weight: bold; padding: 2px 4px; border-radius: 2px;";

    checkLogParam();

    if (store?.getters?.applicationUser?.loggingOption || forceLog || isLocalhost()) {
        data = data ?? "";
        const outData = typeof data === "object" ? JSON.stringify(data) : data;
        const timestamp = new Date();
        const text = `${message} ${outData}`;

        if (useStyle) {
            console.log(`${timestamp} %c${text}`, styled);
        } else {
            console.log(`${timestamp} ${text}`);
        }
    }
}

export function isLocalhost() {
    return typeof location !== "undefined" && location.hostname.includes("localhost");
}

export function checkLogParam() {
    const logQueryString = getQuerystringParameter(queryStrings.LOG);

    if (logQueryString) {
        store?.dispatch(storeActions?.SAVE_LOGGING_OPTION, logQueryString);
    }
}
